import { Link } from "react-router-dom";
import { Sparkles, ArrowRight } from "lucide-react";

// Low-key, honest recommendation card for the "done for you" option. No urgency, no fake stats.
export const AuraCard = ({ headline, subhead }) => (
  <div
    data-testid="aura-card"
    className="border border-white/10 bg-[#0c0c0c] p-6 sm:p-7"
  >
    <div className="flex items-center gap-2 mb-3">
      <Sparkles size={15} className="text-accent" />
      <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-white/40">Optional · Done for you</span>
    </div>
    <h3 className="font-display font-bold text-lg mb-2">{headline || "Want this done for you?"}</h3>
    <p className="font-body text-sm text-white/55 leading-relaxed mb-5">
      {subhead ||
        "If you'd rather not remove yourself from data brokers by hand, there's a subscription service we recommend that does it automatically."}
    </p>
    <Link
      to="/portal/done-for-you"
      data-testid="aura-card-link"
      className="group inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.15em] text-accent hover:text-white transition-colors"
    >
      See the option <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" />
    </Link>
  </div>
);
